'use strict';

var GridToolbarUserManagementRolesDirective = function GridToolbarUserManagementRolesDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-user-management-roles.html')
  };
};
GridToolbarUserManagementRolesDirective.$inject = [];
module.exports = GridToolbarUserManagementRolesDirective;